import { Button, Link } from '@mui/material'
import { Page } from 'components/Shared/Page'
import { Link as RouterLink } from 'react-router-dom'
import { PageHeader } from 'components/Shared/PageHeader'
import { BadgesTable } from 'components/Badges/BadgesTable'

export const JJBadgesPage = () => {
  return (
    <Page
      header={
        <PageHeader
          title="J&J Badges"
          eyebrow="CONTESTS"
          actionButton={
            <Link to="/Contests/JJBadges/New" component={RouterLink}>
              <Button variant="contained" fullWidth>
                Create New J&J Badge
              </Button>
            </Link>
          }
        />
      }
    >
      <BadgesTable category="JJBadge" />
    </Page>
  )
}
